import { Row } from '@tanstack/react-table';
import { NamedEntity } from '../../common/types';
import { formatCodeName, sortStringLower } from '../../common/utils';
import { filterString } from '../../common/utils/filters';
import { DimensionValidFormDataType } from '../types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './ClassifierGroupSelect.translations.json';

const { addTranslations, t } = i18nNsFactory('classifier-group-select');
addTranslations(translations);

export const classifierFilterFn = (
  row: Row<DimensionValidFormDataType>,
  _column: string,
  filter: any
) => {
  if (!filter) {
    return true;
  }

  const { classifier, category } = row.original.classifier || {};
  if (
    classifier &&
    (filterString(classifier.code, filter) ||
      filterString(classifier.name, filter))
  ) {
    return true;
  }
  return (
    !!category &&
    (filterString(category.code, filter) || filterString(category.name, filter))
  );
};

export const classifierSortingFn = (
  a: Row<DimensionValidFormDataType>,
  b: Row<DimensionValidFormDataType>
) => {
  return sortStringLower(
    classifierName(a.original),
    classifierName(b.original)
  );
};

function classifierName(dimension: DimensionValidFormDataType) {
  const { category, classifier } = dimension.classifier || {};
  if (category) {
    return `${category.code} - ${category.name}`;
  }
  if (classifier) {
    return `${classifier.code} - ${classifier.name}`;
  }

  return null;
}

export const getCategoryLabel = (
  allCategories?: boolean | null,
  levelNumber?: number | null,
  category?: NamedEntity | null
) =>
  allCategories
    ? t('all-categories')
    : category
    ? formatCodeName(category)
    : t('level', { levelNumber });
